export const getSupportPageLinks = (o?: { showArticles?: boolean }) =>
    `https://support.knowunity.com/en/support/${o?.showArticles ? 'solutions' : 'home'}`
